import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Icon, Typography, Card, Grid, Divider } from '@material-ui/core'
import clsx from 'clsx'
import * as R from 'ramda'
import AccessControl from 'app/auth/AccessControl'
import { AccessType } from 'app/auth/accessControlService'
import {
  subscriberCountByGroup,
  formatHomelessGroup,
  isEditable,
} from 'commons/groupLogic'
import { TruncatedTextWithTooltip } from 'app/components/TruncatedTextWithTooltip'

export default (props) => {
  const {
    classes,
    keyCount,
    groupDetails,
    toggleDialogs,
    onOpenSubscribers,
    selectedSubgroup,
    RENAME_SUB_GROUP_DIALOG,
    DELETE_SUB_GROUP_DIALOG,
    ADD_SUB_GROUP_DIALOG,
    ALL_SUBGROUPS,
    onClickRename,
    onClickCancelRename,
    readOnly,
    openErrorDialog,
  } = props
  const tagsCount = groupDetails.tags && groupDetails.tags.length

  const { formatMessage } = useIntl()
  const limitSizeSubgroupName = 25
  const { name: groupName, tags } = formatHomelessGroup(
    formatMessage,
    groupDetails,
  )
  const isEditableGroup = isEditable(groupDetails.groupType)

  return (
    <Card className={classes.card}>
      <div className={classes.subgroupCardContent}>
        <div className="flex justify-between px-16 pb-8">
          {groupName && (
            <span
              className="flex"
              onClick={() => onOpenSubscribers(ALL_SUBGROUPS)}
            >
              <TruncatedTextWithTooltip
                text={groupName}
                typographyProps={{
                  variant: 'h6',
                  className: 'cursor-pointer',
                }}
              />
              <Typography
                variant="h6"
                className="ltr:ml-8 rtl:mr-8 cursor-pointer"
              >
                ({subscriberCountByGroup(groupDetails)})
              </Typography>
            </span>
          )}

          <div className="flex flex-row items-center">
            {!readOnly && (
              <AccessControl accesses={[AccessType.ADMINISTRATION]}>
                <>
                  {isEditableGroup ? (
                    <Icon
                      className="cursor-pointer ltr:pr-8 rtl:pl-8"
                      fontSize="small"
                      onClick={() => onClickRename()}
                    >
                      create_outlined_icon
                    </Icon>
                  ) : null}
                  <Icon
                    className="cursor-pointer"
                    fontSize="small"
                    onClick={() =>
                      R.prop('membershipCard', groupDetails)
                        ? openErrorDialog()
                        : onClickCancelRename()
                    }
                  >
                    delete_outline_icon
                  </Icon>
                </>
              </AccessControl>
            )}
          </div>
        </div>
        <Grid container direction="column">
          {keyCount > 0 &&
            tags.map((tagItem, itemKey) => {
              let classesArr = [
                classes.subgroup_item,
                classes.subgroup_item_hover,
                'subgroup_item',
              ]
              selectedSubgroup['id'] === tagItem.id && classesArr.push('active')
              return (
                <Grid item key={itemKey} className={clsx(classesArr)}>
                  <div
                    onClick={() => {
                      onOpenSubscribers(tagItem)
                    }}
                    className={classes.subgroup_item_title}
                  >
                    <Icon className={classes.subgroup_item_icon}>layers</Icon>
                    <div className={classes.subgroup_item_text}>
                      <TruncatedTextWithTooltip
                        text={tagItem.name}
                        limitSize={limitSizeSubgroupName}
                      />
                    </div>
                    {`(${R.path(['subscribers'], tagItem).length})`}
                  </div>
                  {!readOnly && (
                    <AccessControl accesses={[AccessType.ADMINISTRATION]}>
                      <span
                        className={clsx(
                          classes.subgroup_item_action_btn,
                          'subgroup_item_action_btn',
                        )}
                      >
                        {isEditableGroup ? (
                          <span
                            onClick={() => {
                              toggleDialogs(
                                RENAME_SUB_GROUP_DIALOG,
                                true,
                                tagItem,
                              )
                            }}
                          >
                            <Icon className={classes.subgroup_item_icon}>
                              edit
                            </Icon>
                          </span>
                        ) : null}
                        {tagsCount > 1 && (
                          <span
                            onClick={() => {
                              toggleDialogs(
                                DELETE_SUB_GROUP_DIALOG,
                                true,
                                tagItem,
                              )
                            }}
                          >
                            <Icon className={classes.subgroup_item_icon}>
                              delete-forever
                            </Icon>
                          </span>
                        )}
                      </span>
                    </AccessControl>
                  )}
                </Grid>
              )
            })}
        </Grid>
        {!readOnly && (
          <AccessControl accesses={[AccessType.ADMINISTRATION]}>
            <>
              <Divider />
              <Grid
                item
                className={clsx(
                  classes.subgroup_item,
                  classes.subgroup_item_add,
                  'subgroup_item',
                )}
              >
                <span
                  onClick={() => {
                    toggleDialogs(ADD_SUB_GROUP_DIALOG, true)
                  }}
                  className={classes.subgroup_item_title}
                >
                  <Icon className={classes.subgroup_item_icon}>
                    add_circle_outline
                  </Icon>
                  <span className={classes.subgroup_item_text}>
                    <FormattedMessage id="group.details.info.tip.addSubgroup" />
                  </span>
                </span>
              </Grid>
            </>
          </AccessControl>
        )}
      </div>
    </Card>
  )
}
